/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckCircleIcon16Light } from './CheckCircleIcon16Light';
import { CheckCircleIcon16Regular } from './CheckCircleIcon16Regular';
import { CheckCircleIcon16Solid } from './CheckCircleIcon16Solid';
import { CheckCircleIcon20Light } from './CheckCircleIcon20Light';
import { CheckCircleIcon20Regular } from './CheckCircleIcon20Regular';
import { CheckCircleIcon20Solid } from './CheckCircleIcon20Solid';
import { CheckCircleIcon24Regular } from './CheckCircleIcon24Regular';
import { CheckCircleIcon24Solid } from './CheckCircleIcon24Solid';
import { CheckCircleIcon32Regular } from './CheckCircleIcon32Regular';
import { CheckCircleIcon64Regular } from './CheckCircleIcon64Regular';
var sizes = {
    16: {
        light: CheckCircleIcon16Light,
        regular: CheckCircleIcon16Regular,
        solid: CheckCircleIcon16Solid,
    },
    20: {
        light: CheckCircleIcon20Light,
        regular: CheckCircleIcon20Regular,
        solid: CheckCircleIcon20Solid,
    },
    24: {
        regular: CheckCircleIcon24Regular,
        solid: CheckCircleIcon24Solid,
    },
    32: {
        regular: CheckCircleIcon32Regular,
    },
    64: {
        regular: CheckCircleIcon64Regular,
    },
};
export var CheckCircleIcon = forwardRef('CheckCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
